import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {GlobalLoginResponse} from '../../../bff/globalLoginHandler';

export interface AuthState {
  /**
   * 웹뷰 환경 글로벌 이메일 로그인시 약관 업데이트 필요한 유저 케이스에 필요합니다.
   * 약관 업데이트 후 웹에서 로그인 완료하여 결과값을 JS interface로 전달합니다.
   * 웹에서 email, pw를 받아 로그인 하다보니 앱에서는 해당 정보를 알 수 없어 로그인할 수 없기 때문입니다.
   */
  globalLoginResult?: GlobalLoginResponse;
}

const initialState: AuthState = {
  globalLoginResult: undefined,
};

export const loginSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setGlobalLoginResult: (
      state,
      action: PayloadAction<GlobalLoginResponse>
    ) => {
      state.globalLoginResult = action.payload;
    },
    clearGlobalLoginResult: state => {
      state.globalLoginResult = undefined;
    },
  },
});

export const {setGlobalLoginResult, clearGlobalLoginResult} =
  loginSlice.actions;
